module.exports = __webpack_public_path__ + "static/media/sky-terrace-2.4832f5ad.jpg";